import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const B58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

export const SAMPLE_TOKENS = [
  { label: "BONK", address: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263" },
  { label: "JUP", address: "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN" },
  { label: "WIF", address: "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm" },
  { label: "USDC", address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v" },
];

export function addressError(raw) {
  const a = (raw || "").trim();
  if (!a) return "Enter a Solana token mint address.";
  if (a.length < 32 || a.length > 44) return "Solana addresses are 32–44 characters long.";
  let n = BigInt(0);
  for (const c of a) {
    const i = B58.indexOf(c);
    if (i < 0) return `Invalid character "${c}". Solana addresses use base58 (no 0, O, I or l).`;
    n = n * BigInt(58) + BigInt(i);
  }
  let bytes = 0;
  while (n > BigInt(0)) {
    n >>= BigInt(8);
    bytes += 1;
  }
  const pad = a.length - a.replace(/^1+/, "").length;
  return bytes + pad === 32 ? null : "This does not decode to a valid 32-byte Solana public key.";
}

export const fetchToken = (address, refresh = false) =>
  axios.get(`${API}/token/${address}`, { params: refresh ? { refresh: true } : {} }).then((r) => r.data);
export const fetchDemo = () => axios.get(`${API}/demo-report`).then((r) => r.data);
export const joinWaitlist = (body) => axios.post(`${API}/waitlist`, body).then((r) => r.data);

export const shorten = (a, n = 4) => (a ? `${a.slice(0, n)}…${a.slice(-n)}` : "—");

const compact = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 2 });
export const fmtNum = (v) => (v === null || v === undefined ? "—" : compact.format(v));
export const fmtUsd = (v) => (v === null || v === undefined ? "—" : `$${compact.format(v)}`);
export const fmtPct = (v, d = 2) => (v === null || v === undefined ? "—" : `${Number(v).toFixed(d)}%`);
export function fmtPrice(v) {
  if (v === null || v === undefined) return "—";
  if (v >= 1) return `$${v.toLocaleString("en-US", { maximumFractionDigits: 4 })}`;
  return `$${Number(v).toPrecision(4)}`;
}
export function timeAgo(iso) {
  if (!iso) return "—";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "medium" }) : "—";
